import React from "react";
import { HeadConsult } from "./Head";
import { ClinicalBudgetMain } from "./Steps/ClinicalBudgetMain";
import { ClinicalBudgetConfig } from "./Steps/ClinicalBudgetConfig";
import { ClinicalBudgetConfirm } from "./Steps/ClinicalBudgetConfirm";
import { useClinicalBudget } from "shared/providers/ClinicalBudget";

const ClinicalBudgetStep: React.FC = () => {
  const { step, showValues } = useClinicalBudget();

  // Quando showValues = false, são apenas 2 passos (1 e 3)
  // Quando showValues = true, são 3 passos normais
  const getTotalSteps = () => showValues ? 3 : 2;
  const getCurrentStepNumber = () => {
    if (!showValues && step === 3) return 2;
    return step;
  };

  const stepTitle = [
    step === 1 && `1 de ${getTotalSteps()} - Procedimentos`,
    step === 2 && showValues && `2 de ${getTotalSteps()} - Configurações`,
    step === 3 && `${getCurrentStepNumber()} de ${getTotalSteps()} - Confirmação`,
  ];

  return (
    <>
      <HeadConsult title={stepTitle}>
        {step === 1 && <ClinicalBudgetMain />}
        {step === 2 && showValues && <ClinicalBudgetConfig />}
        {step === 3 && <ClinicalBudgetConfirm />}
      </HeadConsult>
    </>
  );
};

export { ClinicalBudgetStep };


